module.exports = __webpack_public_path__ + "img/020082.1be9d97d.png";